import React from 'react';
//import ApprovalList from './ApprovalList';
//import Header from './Header';
//import SystemList from './SystemsList';
//import User from './User';
//import MobileSystemsList from './MobileSystemsList';
import HeaderBs from './HeaderBs';
import SideBarBs from './SideBarBs';
import NotificationListBs from './NotificationListBs';
import MiddleHeaderBs from './MiddleHeaderBs';
import HeaderFilterBs from './HeaderFilterBs';



const Home = () => {

    return (
        <div className="wrapper">
            {/* <PopUpNotification /> */}
            <HeaderBs />
            <SideBarBs />
            <div className="main-panel">
                <div className="container">
                    <MiddleHeaderBs />
                    <div className="page-inner mt--5">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card full-height">
                                    <HeaderFilterBs />
                                    <NotificationListBs />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Home;